import React from 'react';
import PropTypes from 'prop-types';
import { Card, Button, Spinner, Badge } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { icon } from '@fortawesome/fontawesome-svg-core/import.macro';
import InfoList from './InfoList';

const formatDate = (value) => {
  try {
    if (!value) return "";
    const d = new Date(value);
    return d.toLocaleDateString('es-MX', { day: '2-digit', month: 'short', year: 'numeric' });
  } catch {
    return value;
  }
};

const DescriptionPanel = ({ gasto, onDownload, downloading }) => {
  const leftItems = [
    { label: 'Tipo de Gasto', value: gasto?.vTipoGasto },
    { label: 'Responsable', value: gasto?.vResponsable },
    { label: 'Forma de Pago', value: gasto?.vFormaPago },
    { label: 'Cuenta Bancaria', value: gasto?.DetallesCuenta },
    { label: 'Fecha', value: formatDate(gasto?.dFechaGasto) }
  ];

  const facturaUrl = gasto?.idFacturaRecibida > 0 ? `/contabilidad/facturacion/facturas-recibidas/visualizacion/${gasto.idFacturaRecibida}` : null;

  return (
    <Card className="h-100 shadow-sm">
      <Card.Body>
        <div style={{ whiteSpace: 'pre-wrap', wordBreak: 'break-word', fontSize: '1.15rem', fontWeight: 700, lineHeight: '1.4' }} className="mb-3">
          {gasto?.vDescripcion || '-'}
        </div>

        <InfoList items={leftItems} />

        {gasto?.vObservaciones && (
          <div className="mt-3">
            <div className="small text-muted mb-1">Observaciones</div>
            <div className="p-2 bg-light rounded small" style={{ whiteSpace: 'pre-wrap' }}>{gasto.vObservaciones}</div>
          </div>
        )}
      </Card.Body>

      <Card.Footer className="d-flex justify-content-between align-items-center border-0 bg-white">
        <div>
          {gasto?.fileNota && <Badge bg="success" className="me-2">Nota local</Badge>}
          {facturaUrl && (
            <a href={facturaUrl} target="_blank" rel="noopener noreferrer">
              <Button variant="outline-secondary" size="sm" className="me-2">
                <FontAwesomeIcon icon={icon({ name: 'file-invoice', style: 'solid' })} className="me-1" />
                Ver factura
              </Button>
            </a>
          )}
        </div>
        <div>
          {gasto?.bHasNotaVenta === 1 && (
            <Button variant="primary" size="sm" onClick={onDownload} disabled={downloading}>
              {downloading ? (
                <><Spinner animation="border" size="sm" />&nbsp;Descargando...</>
              ) : (
                <><FontAwesomeIcon icon={icon({ name: 'download', style: 'solid' })} />&nbsp; Descargar nota</>
              )}
            </Button>
          )}
        </div>
      </Card.Footer>
    </Card>
  );
};

DescriptionPanel.propTypes = {
  gasto: PropTypes.object,
  onDownload: PropTypes.func.isRequired,
  downloading: PropTypes.bool
};

DescriptionPanel.defaultProps = {
  downloading: false
};

export default DescriptionPanel;
